import { render } from "./LogoutButton.vue?vue&type=template&id=95f2edfa"
import script from "./LogoutButton.vue?vue&type=script&lang=js"
export * from "./LogoutButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Auth/LogoutButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95f2edfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95f2edfa', __exports__)) {
    api.reload('95f2edfa', __exports__)
  }
  
  module.hot.accept("./LogoutButton.vue?vue&type=template&id=95f2edfa", () => {
    api.rerender('95f2edfa', render)
  })

}


export default __exports__